import cx from 'classnames'
import { ReactNode, useState } from 'react'
import { UseFormRegisterReturn } from 'react-hook-form'

import CheckboxTick from './tick'

interface CheckboxProps {
  id: string
  formRegister: UseFormRegisterReturn
  defaultChecked?: boolean
  errorMessage?: string
  children?: ReactNode
  isInvertedColors?: boolean
  className?: string
}

const Checkbox = ({
  id,
  formRegister,
  defaultChecked,
  errorMessage,
  children,
  className,
  isInvertedColors,
}: CheckboxProps) => {
  const [checked, setChecked] = useState(!!defaultChecked)

  return (
    <div className={cx('relative', className)}>
      <input
        id={`${id}-checkbox`}
        type="checkbox"
        ref={formRegister.ref}
        name={formRegister.name}
        checked={checked}
        onBlur={(event) => {
          formRegister.onBlur(event)
        }}
        onChange={(event) => {
          setChecked(event.target.checked)
          formRegister.onChange(event)
        }}
        className="absolute w-[1px] h-[1px] p-0 m-[-1px] overflow-hidden whitespace-nowrap border-none opacity-0"
      />
      <label
        htmlFor={`${id}-checkbox`}
        className="relative inline-flex items-center transform-none top-auto left-auto mx-auto p-0 cursor-pointer"
      >
        <CheckboxTick
          isChecked={checked}
          className={cx({
            'border-input-border': !isInvertedColors,
            'border-input-inverted-border': isInvertedColors,
            'delay-150': !checked,
            'delay-0': checked,
          })}
        />
        <div>{children}</div>
      </label>

      {!!errorMessage && (
        <span role="alert" className="block mt-1 text-xs text-error">
          {errorMessage}
        </span>
      )}
    </div>
  )
}

export default Checkbox
